export const SUPPORT_PHONE = '+91-8796447298';
export const SUPPORT_PHONE_TEL = '+918796447298';
export const WHATSAPP_NUMBER = '918796447298';
export const SUPPORT_EMAIL = 'info@credit99.com';
export const GRIEVANCE_EMAIL = 'grievance@credit99.com';
export const NODAL_EMAIL = 'nodal@credit99.com';
export const BRAND_NAME = 'Credit99';
export const BRAND_TAGLINE = 'salary ka backup plann.';
